export default __webpack_public_path__ + "static/media/followParticipants.d43e3bcc.svg";